export default "//yastatic.net/s3/distribution/pythia/frontend/_/7411176fd11c006402445c43edc325c7.png";